import React from 'react';
import { Grid, Autocomplete, TextField } from '@mui/material';
import { updateAuthorizationData } from '../../../../redux/slices/authorizationDataSlice';
import { updateErrorFields } from '../../../../redux/slices/submitFormErrorSlice';

// Portfolio Manager is the sole approver for Europe Lease Authorization (TLGR-4740 / TLGR-4741).
// Selecting a Portfolio Manager also seeds authorizationData.selectedApprovers with a single
// approver entry so the generic submit/approve/reject pipeline (built around Approvers[0])
// works unchanged, without going through the fund-threshold AuthApprovers/AuthApproverLevels engine.
const PortfolioManagerField: React.FC<any> = ({ formData, selectedPortfolioManager, setSelectedPortfolioManager, dispatch, submitErrorModel, authorizationData }) => {
  return (
    <Grid item xs={12} md={6}>
      <Grid>
        <label htmlFor="field3">Portfolio Manager</label> <span className="mandatory"> * </span>
      </Grid>
      <Grid>
        <Autocomplete
          fullWidth
          size="small"
          disablePortal
          disabled={!formData?.isFormEditable}
          data-testid="property-select portfolio"
          value={selectedPortfolioManager}
          options={formData?.portfolioManager ?? []}
          getOptionLabel={(option: any) => option?.name}
          isOptionEqualToValue={(option: any, value: any) => option?.name === value?.name}
          onChange={(event, newInputValue: any) => {
            setSelectedPortfolioManager(newInputValue ? newInputValue : { name: "", email: "" });
            dispatch(updateErrorFields({
              ...submitErrorModel.data,
              portfolioManager: false
            }));
            dispatch(updateAuthorizationData({
              ...authorizationData,
              portfolioManager: newInputValue ? newInputValue?.name : "",
              portfolioManagerEmail: newInputValue ? newInputValue?.email : "",
              selectedApprovers: newInputValue ? [{
                name: newInputValue?.name ?? "",
                approver: 1,
                mail: newInputValue?.email ?? "",
                level: "Portfolio Manager",
                comments: "",
                isApproved: false
              }] : []
            }));
          }}
          renderInput={(params) => <TextField {...params} role="portfolio manager"
            error={submitErrorModel.data.portfolioManager} />}
        />
      </Grid>
    </Grid>
  );
};

export default PortfolioManagerField;
